import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useAuth } from "@/context/auth-context";

interface VerifyReleaseLabelExistenceRequest {
  releaseLabelName: string;
  promptName: string;
}

interface VerifyReleaseLabelExistenceResponse {
  success: boolean;
  exists: boolean;
  error?: string;
}

export const useVerifyReleaseLabelExistence = ({
  releaseLabelName,
  promptName,
  enabled = true,
}: VerifyReleaseLabelExistenceRequest & { enabled?: boolean }) => {
  const auth = useAuth();
  const { workspaceId } = useParams();
  const userToken = auth?.userToken || "";

  const url = new URL(ENDPOINTS.verify_release_label_existence);
  url.searchParams.set("workspace_id", workspaceId!);
  url.searchParams.set("release_label_name", releaseLabelName);
  url.searchParams.set("prompt_name", promptName);

  return useQuery<VerifyReleaseLabelExistenceResponse>({
    queryKey: ["verify-release-label-existence", workspaceId, releaseLabelName, promptName],
    queryFn: () =>
      fetch(url.toString(), {
        headers: authHeader(userToken),
      }).then(handleResponse),
    enabled: enabled && !!workspaceId && !!releaseLabelName && !!promptName && !!userToken,
    staleTime: 5 * 60 * 1000,
  });
};
